import { isString } from "lodash";

export function GetFriendlyError(error: any): string {
  try {
    if (error?.response?.data?.message) {
      return error.response.data.message;
    }
    if (isString(error)) {
      return error as string;
    }
  } catch (e) {
    console.log(e);
  }
  return "Error: Unknown Error";
}

export const getFileExtension = (fileNameRaw: string): string => {
  const fileName = fileNameRaw.toLowerCase();
  const match = fileName.match(/[0-9a-z]+$/);
  if (!match || !match[0]) {
    console.log('Not a valid filename');
    throw new Error('Not a valid filename');
  }
  return match[0];
};
